/*
 * @Author: taowuhua
 * @:
 * @Date: 2024-11-18 09:50:41
 * @LastEditors: taowuhua
 * @LastEditTime: 2024-11-25 16:02:53
 * @Description: file content
 */
import Vue from "vue"
import VueRouter from "vue-router"
import Home from "@/components/home.vue" // 引入hemo.vue组件
import userInfo from "@/components/userInfo.vue" //个人信息
import JinQifahui from "@/components/jinqifahui.vue" //近期发会
import fashidengji from "@/components/fashidengji.vue" //法事登记
import xinxidengji from "@/components/xinxidengji.vue" //信息登记
import userAdd from "@/components/userAdd.vue" //信息登记新增页面
import paiweidengji from "@/components/paiweidengji.vue" //牌位登记+结算
import ceshi from "@/components/ceshi.vue" //牌位登记+结算
import fawuqingfeng from "@/components/fawuqingfeng.vue" //待办服务
import querenxinxi from "@/components/querenxinxi.vue" //确认信息
import donationQuerenxinxi from "@/components/donationQuerenxinxi.vue" //确认信息
import Donation from "@/components/donation.vue" //确认信息
import DonationDetail from "@/components/donationDetail.vue" //确认信息
import DonationRegistration from "@/components/DonationRegistration.vue" //确认信息
import Login from "@/components/login.vue" //登录
import ZhiFu from "@/components/zhifu.vue" //支付
import QuBuDingDan from "@/components/quanbudingdan.vue" //支付
import QuanBuDingDanDetail from "@/components/quanbudingdandetail.vue" //支付
import quanbudingdandetailCopy from "@/components/quanbudingdandetailCopy.vue" //支付
import HeTong from "@/components/hetong.vue" //合同
import jinqihuodong from "@/components/jinqihuodong.vue" //近期活动
import jinqihuodongdetail from "@/components/jinqihuodongdetail.vue" //近期活动详情
import huodongdengji from "@/components/huodongdengji.vue" //活动登记
import huodongdengjiqueren from "@/components/huodongdengjiqueren.vue" //活动登记
import jingshengongdezhifu from "@/components/jingshengongdezhifu.vue" //
import contactList from "@/components/contactList.vue" //活动登记
Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: "/", // 设置根路径
      name: "Home",
      component: Home,
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: userInfo,
    },
    {
      path: "/JinQifahui",
      name: "JinQifahui",
      component: JinQifahui,
    },
    {
      path: "/fashidengji",
      name: "fashidengji",
      component: fashidengji,
    },
    {
      path: "/xinxidengji",
      name: "xinxidengji",
      component: xinxidengji,
    },
    {
      path: "/userAdd",
      name: "userAdd",
      component: userAdd,
    },
    {
      path: "/paiweidengji",
      name: "paiweidengji",
      component: paiweidengji,
    },
    {
      path: "/ceshi",
      name: "ceshi",
      component: ceshi,
    },
    {
      path: "/fawuqingfeng",
      name: "fawuqingfeng",
      component: fawuqingfeng,
    },
    {
      path: "/querenxinxi",
      name: "querenxinxi",
      component: querenxinxi,
    },
    {
      path: "/donationQuerenxinxi",
      name: "donationQuerenxinxi",
      component: donationQuerenxinxi,
    },
    {
      path: "/Donation",
      name: "Donation",
      component: Donation,
    },
    {
      path: "/DonationDetail",
      name: "DonationDetail",
      component: DonationDetail,
    },
    {
      path: "/DonationRegistration",
      name: "DonationRegistration",
      component: DonationRegistration,
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    {
      path: "/ZhiFu",
      name: "ZhiFu",
      component: ZhiFu,
    },
    {
      path: "/QuBuDingDan",
      name: "QuBuDingDan",
      component: QuBuDingDan,
    },
    {
      path: "/QuanBuDingDanDetail",
      name: "QuanBuDingDanDetail",
      component: QuanBuDingDanDetail,
    },
    {
      path: "/HeTong",
      name: "HeTong",
      component: HeTong,
    },
    {
      path: "/quanbudingdandetailCopy",
      name: "quanbudingdandetailCopy",
      component: quanbudingdandetailCopy,
    },
    {
      path: "/jinqihuodong",
      name: "jinqihuodong",
      component: jinqihuodong,
    },
    {
      path: "/jinqihuodongdetail",
      name: "jinqihuodongdetail",
      component: jinqihuodongdetail,
    },
    {
      path: "/huodongdengji",
      name: "huodongdengji",
      component: huodongdengji,
    },
    {
      path: "/huodongdengjiqueren",
      name: "huodongdengjiqueren",
      component: huodongdengjiqueren,
    },
    {
      path: "/jingshengongdezhifu",
      name: "jingshengongdezhifu",
      component: jingshengongdezhifu,
    },
    {
      path: "/contactList",
      name: "contactList",
      component: contactList,
    },
  ],
})
